<div class="entity-picker" id="entity-picker" #selectionBox>
  <div class="entity-selected-icon">
    <i [ngClass]="selectedIcon | async"
       [appCustomOverlayTriggerFor]="entitySelect"
       [shouldClose]="shouldEntityPickerClose">
    </i>
  </div>
  <app-entity-select
    #entitySelect
    [entities]="entities"
    [entitySelectorsMap]="entitySelectorsMap"
    [isSelected]="isSelected"
    [descriptorControl]="descriptorControl"
    [renderIcon]="renderIcon"
    [onToggle]="onToggle"
    [primaryEntity]="primaryEntity"
    [overlayPositioningConfig]="overlayPositioningConfig">
  </app-entity-select>
</div>
